const WALLPAPER_STORAGE_KEY = 'savedSpotifyAlbums'
class WallpaperManager {
	savedAlbums = []
	constructor(spotifyClient) {
		this.spotifyClient = spotifyClient
		this.loadSavedWallpaper()
	}
	loadSavedWallpaper() {
		let savedSpotifyAlbums = window.localStorage.getItem(WALLPAPER_STORAGE_KEY)
		if (savedSpotifyAlbums) {
			let albumPrototypes = JSON.parse(savedSpotifyAlbums)
			this.savedAlbums = albumPrototypes.map(x => this.spotifyClient.createAlbum(x))
		}
	}
	albumsToJson() {
		return JSON.stringify(this.savedAlbums)
	}
	getAllAlbums() {
		return this.savedAlbums
	}
	add(album) {
		this.savedAlbums.push(album)
		this.save()
	}
	save() {
		window.localStorage.setItem(WALLPAPER_STORAGE_KEY, JSON.stringify(this.savedAlbums))
	}
	remove(i) {
		this.savedAlbums.splice(i, 1)
		this.save()
	}
	downloadImage(width, height) {
		let images = document.getElementsByClassName("saved-album-art-img")
		let canvas = document.createElement("canvas")
		canvas.width = width * 300
		canvas.height = height * 300
		let context = canvas.getContext('2d')
		let i = 0, j = 0
		for (let image of images) {
			context.drawImage(image, 300 * i, 300 * j, 300, 300)
			if (++i === width) {
				i = 0
				if (++j === height) {
					break
				}
			}
		}
		document.getElementById("download-wallpaper").href = canvas.toDataURL()
		canvas.remove()
		setTimeout(() => {
			document.getElementById("download-wallpaper").href = ""
		}, 2000)
	}
	setWallpaperSize(width, height, resX, resY) {
		this.width = width
		this.height = height
	}
	shuffleArt() {
		for (let i = this.savedAlbums.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1))
			const temp = this.savedAlbums[i]
			this.savedAlbums[i] = this.savedAlbums[j]
			this.savedAlbums[j] = temp
		}
		this.save()
	}
	// deleteSavedData() {
	// 	this.savedAlbums = []
	// 	this.save()
	// }
}

export default WallpaperManager
